import { DetailOrderEstimate } from './detail-order-estimate.model';

export abstract class AbstractProductItemOrderEstimate {
  productId: number;
  productsQuantity: number;
  details: Array<DetailOrderEstimate>;
  pocketsChequeQuantity: number;
  packagingId: number;
}
